module.exports = __webpack_public_path__ + "img/veterinar-palan.74db67f6.jpg";